import styled from "styled-components";

export const Container = styled.div`
  gap: 5px;
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: center;
`;

export const Dot = styled.div`
  width: 8px;
  height: 8px;
  border-radius: 100px;
  background-color: ${({theme}) => theme["primary"]};
`;
